import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncMainPublicHoliday({ ...rest }) {
  const AsyncLoad = loadable(() => import("../admin/MainPublicHoliday"));
  console.log("Loading", AsyncMainPublicHoliday.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncMainPublicHoliday;
